import EventEmitter from 'eventemitter3'
import { BarcodeEvent } from '../types/barcode'

// Singleton EventEmitter instance for barcode scanning events
export const barcodeEventEmitter = new EventEmitter<{ scan: BarcodeEvent }>()
